<div class="overlay-wrapper primary-bg dropdown-shadow p-3  border-light radius-m">
    <div class="header-wrapper  radius-m primary-bg">
        <div class="header-content border-light-bottom pt-3 pb-6" >
            <p class="primary-text content-l  bold-text enable-action" (click)="entityClear()">{{header}}</p>
            <ng-container *ngIf="selectedEntity">
                <ng-container *ngFor="let head of selectedEntity; index as i">
                    <p class="primary-text content-l  bold-text">></p>
                    <p class="primary-text content-m  enable-action" (click)="headerClick(head.value,i)">{{head.disp}}</p>
                </ng-container>
            </ng-container>
        </div>
        <ng-container *ngIf="isSearch">
            <div class="custom-search pl-3 pr-10 pb-3 pt-3">
                <img class="icon-s" src="assets/settings/search-small.svg">
                <input class="input-border  border-m" type="search" id="input"  placeholder="Type to search here" [(ngModel)]="searchText"  (input)="onSearchChange()">
            </div>
        </ng-container>
    </div>
    <div class="body-wrapper border-light-top white-bg ">
        <div #origin class="body-content pb-3">
          
            <div class="entity">
                <ng-container *ngFor="let entity of filteredData">
                    <p class="primary-text content-m p-3 border-light-bottom enable-action"[ngClass]="entity.state == '0' ?'permission-denied':''" (click)="entityClick(entity)">{{entity.disp}}</p>
                </ng-container>
            </div>
        </div>
    </div>
</div>
